import * as SVG from 'svg.js';

import { DragSensor } from '../image-cropper/drag-sensor';
import { PositioningHints
       } from '../../collage-designer/stage/placeholder/overlays/action-bar/action-bar.component'; // tslint:disable-line

export interface Position {
  x: number;
  y: number;
}

export interface Placement {
  x?: number;
  y?: number;
  width?: number;
  height?: number;
  rotation?: number;
}

export interface DragInfo {
  delta: Position;
  absolute: Position;
  reference: SVG.Box;
  ctm: SVG.Matrix;
}

export interface RoughBox {
  x: number;
  y: number;
  width: number;
  height: number;
}

export abstract class HandleBase {
  private sensor: DragSensor;
  private dragReference: DragInfo;

  public onRequestUpdate: (place: Placement) => void = () => {};
  public onDragEnd: () => void = () => {};
  public onClick: () => void = () => {};

  constructor(
    protected element: SVG.Element, protected control: SVG.Element)
  {
    this.sensor = new DragSensor(this.control);

    const transform = (p: Position, matrix: SVG.Matrix) => (
      new SVG.Point(p.x, p.y).transform(matrix) as any);

    this.sensor.onDragBegin = () => {
      const screenCTM = this.control.screenCTM();

      const centerControl =
        transform({x: this.control.cx(), y: this.control.cy()}, screenCTM);

      const centerElement =
        transform({x: this.element.cx(), y: this.element.cy()}, screenCTM);

      this.dragReference = {
        delta: this.control.point(0, 0) as any,
        absolute: {
          x: centerControl.x - centerElement.x,
          y: centerControl.y - centerElement.y,
        },
        reference: {
          ... this.element.bbox(),
          x: this.element.x(),
          y: this.element.y(),
          width: this.element.width(),
          height: this.element.height(),
        },
        ctm: screenCTM.inverse(),
      };
    };

    const relativePoint = (p: Position) => {
      const pDoc = transform(p, this.dragReference.ctm);
      const pOrigin = this.dragReference.delta as any;

      return {x: pDoc.x - pOrigin.x, y: pDoc.y - pOrigin.y};
    };

    this.sensor.onDrag = (info) => {
      const docDelta = relativePoint(info.delta);

      const place = this.drag({
        ... this.dragReference,
        delta: docDelta,
        absolute: {
          x: this.dragReference.absolute.x + info.delta.x,
          y: this.dragReference.absolute.y + info.delta.y,
        },
      });

      window.requestAnimationFrame(() => this.onRequestUpdate(place));
    };

    this.sensor.onClick = () => this.onClick();
    this.sensor.onDragEnd = () => window.requestAnimationFrame(this.onDragEnd);
  }

  public update(bounds: RoughBox): void {
    this.updateControl(bounds);
  }

  public teardown(): void {
    this.sensor.destructor();
  }

  public get actionBarPositioningHints(): PositioningHints
  {
    return {};
  }

  protected abstract updateControl(bounds: RoughBox): void;
  protected abstract drag(info: DragInfo): Placement;
  public dragEnd(): void
  { }

  protected roughCenter(element: SVG.Element,
                        x: number,
                        y: number,
                        widthHint?: number,
                        heightHint?: number): void
  {
    const width = widthHint || element.width();
    const height = heightHint || element.height();
    element.move(x - (width / 2), y - (height / 2));
  }
}



// WEBPACK FOOTER //
// ./src/app/controls/transform-handle/handle.base.ts